import { render, staticRenderFns } from "./ClientCard.vue?vue&type=template&id=16fa1dda&scoped=true"
import script from "./ClientCard.vue?vue&type=script&lang=ts"
export * from "./ClientCard.vue?vue&type=script&lang=ts"
import style0 from "./ClientCard.vue?vue&type=style&index=0&id=16fa1dda&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fa1dda",
  null
  
)

export default component.exports